import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { Link } from "react-router-dom";
import { useWizard } from "react-use-wizard";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import createPersistedState from "use-persisted-state";
import { getTranslatedClinicNameFromId } from "../../utils";
import { useCallback } from "react";
const useClinicState = createPersistedState("clinic");

function SelectTimeStep({
  currentDate,
  setCurrentSlot,
  selectedClinic,
  recDoctor,
  isReschedule,
  availableClinics,
}) {
  const { previousStep, nextStep } = useWizard();
  const [appointment, setAppointment] = useState([]);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const { t } = useTranslation();
  const [clinicId, setClinic] = useClinicState();

  //to get Date format
  const selectedDate = localStorage.getItem("Date");
  const finalDate = new Date(selectedDate);
  // console.log(selectedDate);
  // console.log(finalDate);

  const fromDate = `${finalDate.getFullYear()}-${
    finalDate.getMonth() + 1
  }-${finalDate.getDate()}`;

  // fetch URL
  const patientId = JSON.parse(localStorage.getItem("pid"));

  const getURL = useCallback(
    (selectedClinic) =>
      `/api/v1/appointments/slots?days=60&spaceId=${selectedClinic}&ownerId=${
        recDoctor.drId
      }&fromDate=${fromDate}&attendeeId=${patientId}${
        isReschedule ? "&reschedule=true" : ""
      }`,
    [recDoctor.drId, fromDate, patientId, isReschedule]
  );

  useEffect(() => {
    setAppointment(currentDate.slots);
    const fetchData = async () => {
      let data;
      setIsFetchingData(true);
      const token = "Bearer " + localStorage.getItem("token");
      try {
        if (selectedClinic !== "CC000000") {
          const response = await fetch(getURL(selectedClinic), {
            method: "GET",
            headers: {
              Accept: "application/json; charset=utf-8",
              Authorization: token.replace(/['"]+/g, ""),
            },
            credentials: "include",
          });
          data = await response.json();
          console.log(data);
          const availableBooking = data.dates[0].slots.filter((cValue) => {
            return cValue.available === true;
          });
          setAppointment(availableBooking);
          if (!response.status === 200) {
            const error = new Error(response.error);
            throw error;
          }
        }
      } catch (err) {
        console.log(err);
      }
      setIsFetchingData(false);
    };

    //I dont see why fetching time slots again is necessary for now, Hence proceding with earlear selected slot.
    // fetchData();
  }, [URL]);

  const goToConfirmAppointment = (e, cValue) => {
    console.log(cValue);
    if (cValue.available === false) {
    } else {
      setCurrentSlot(cValue);
      nextStep();
    }
  };

  const TimeSlotListing = () => {
    return (
      <ul className="list-unstyled list_timeslot">
        {appointment.map((cValue) => {
          return (
            <li
              key={cValue.id}
              onClick={(e) => goToConfirmAppointment(e, cValue)}
            >
              <Link
                to="#"
                style={{ backgroundColor: "#b9f2d3", color: "000" }}
                className={cValue.available === false ? "disabled" : ""}
              >
                <span className="txt">
                  {moment(cValue.id).format("hh:mm A")}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={() => previousStep()}
        title={t("appointment.TIME.time")}
      />
      <div className="body_content py-3">
        <div className="inner_body ">
          <div className="timeslot_block">
            <p className="txt_slot">
              {moment(new Date(fromDate)).format("Do MMMM YYYY, dddd")}
              <span className="txt_loc d-block">
                {getTranslatedClinicNameFromId(selectedClinic, t)}
              </span>
            </p>
            <p className="txt_slot">
              {/* <strong>{t("appointment.CONFIRMED.doctor-name")}</strong> */}
              <strong>{recDoctor.drName}</strong>
            </p>
          </div>
          {isFetchingData ? (
            <div
              style={{
                margin: "auto",
                display: "flex",
                justifyContent: "center",
              }}
              id="loader"
            ></div>
          ) : (
            <TimeSlotListing />
          )}
        </div>
      </div>
    </>
  );
}

export default SelectTimeStep;
